import { useState } from "react"
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory"
import { getConfiguredLabel } from "../../common/commonHelper"
import { browse, DocumentsPage, dragndropBulkMessage, HomePage, supported, svg, uploadIcon } from "../../common/labelConstants"
import UploadFile from "../upload/filePond"


const _props = {
    handleSetFileList: () => {

    },
    handleSetUploadComplete: () => {

    }
}
export function UploadBulkUsers(props = _props) {
    const [files,setFiles] = useState([])

    const config = {
        allowedFileSizeInMb: 5,
        allowedMaxFilesInSingleUpload: 1,
        allowedMimeTypes: ["application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ],
        browse: getConfiguredLabel(HomePage,browse),
        dragnDrop: getConfiguredLabel(DocumentsPage,dragndropBulkMessage),
        upload: getConfiguredLabel(svg,uploadIcon),
        supportedFilesMsg : getConfiguredLabel(DocumentsPage,supported),

    }
    const setFilesCb =(arr)=>{

        setFiles(arr)
     }
    return <UploadFile
    setFilesCb={setFilesCb}
        onUploadComplete={({ isUploadComplete, metadataForm, fileList, onSaveSuccess_callBack }) => {
            if (isUploadComplete === true) {
                props.handleSetFileList(fileList);
            }
            props.handleSetUploadComplete(isUploadComplete);
            return null;
        }}
        allowFileRename={false}
        allowFileTagging={false}
        config={config}
        bulkErrorList={props.errorsList}
        handleSetErrors = {props.handleSetErrors}/>
}